export enum Role {
    PETITIONER = <any>'PETITIONER',
    CLERK = <any>'CLERK',
    ATTORNEY = <any>'ATTORNEY',
    JUDGE = <any>'JUDGE',
    APPRAISER = <any>'APPRAISER',
    GUARDIAN = <any>'GUARDIAN',
    ASSESSOR = <any>'ASSESSOR',
    HEIR = <any>'HEIR',
    GUARDIANADLITEM = <any>'GUARDIANADLITEM'
}



// WEBPACK FOOTER //
// ./src/app/main/shared/models/role.ts